import {
  CLEAR_VACANCY,
  FETCH_VACANCY_OVERVIEW_SUCCESS,
  CLEAR_VACANCY_CANDIDATES,
  FETCH_VACANCY_CANDIDATES_SUCCESS,
  CLEAR_VACANCY_CONTRACTS,
  FETCH_VACANCY_CONTRACTS_SUCCESS,
  FETCH_VACANCY_SKILLVENDORS_BY_CRITERIA_SUCCESS,
  CLEAR_VACANCY_SKILLVENDORS_BY_CRITERIA
} from '../../../actions/pages/vacancy-page'

export function vacancyPage (
  state = {
    overview: null,
    candidates: null,
    contracts: null,
    skillVendorsByCriteria: []
  },
  action
) {
  switch (action.type) {
    case CLEAR_VACANCY: {
      return Object.assign({}, state, {
        overview: null,
        candidates: null,
        contracts: null,
        skillVendorsByCriteria: []
      })
    }
    case FETCH_VACANCY_OVERVIEW_SUCCESS: {
      return Object.assign({}, state, {
        overview: action.overview
      })
    }
    case CLEAR_VACANCY_CANDIDATES: {
      return Object.assign({}, state, {
        candidates: null
      })
    }
    case FETCH_VACANCY_CANDIDATES_SUCCESS: {
      return Object.assign({}, state, {
        candidates: action.candidates
      })
    }
    case CLEAR_VACANCY_CONTRACTS: {
      return Object.assign({}, state, {
        contracts: null
      })
    }
    case FETCH_VACANCY_CONTRACTS_SUCCESS: {
      return Object.assign({}, state, {
        contracts: action.contracts
      })
    }
    case FETCH_VACANCY_SKILLVENDORS_BY_CRITERIA_SUCCESS: {
      return Object.assign({}, state, {
        skillVendorsByCriteria: action.skillVendorsByCriteria
      })
    }
    case CLEAR_VACANCY_SKILLVENDORS_BY_CRITERIA: {
      return Object.assign({}, state, {
        skillVendorsByCriteria: []
      })
    }
    default:
      return state
  }
}
